import { Card, Col, Row, Tag, Typography } from 'antd';
import type { AiArtifact } from '../../../types/ai-analysis.types';
export default function AiArtifactComparison({ artifacts }: { artifacts: AiArtifact[] }) {
  return (
    <Row gutter={[16, 16]}>
      {artifacts.map((artifact) => (
        <Col xs={24} lg={12} key={artifact.id}>
          <Card
            title={`${artifact.providerCode} — ${artifact.modelName}`}
            extra={<Tag>{artifact.reviewStatus}</Tag>}
          >
            <Typography.Text type="secondary">
              Gerado em {new Date(artifact.createdAt).toLocaleString('pt-BR')}
            </Typography.Text>
            <pre style={{ whiteSpace: 'pre-wrap' }}>
              {JSON.stringify(artifact.normalizedPayload, null, 2)}
            </pre>
          </Card>
        </Col>
      ))}
    </Row>
  );
}
